import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  class: "h-3 w-3 shrink-0",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = {
  viewBox: "0 0 24 24",
  class: "h-3 w-3",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = {
  viewBox: "0 0 24 24",
  class: "h-3 w-3",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]

import { mdiCallMerge, mdiCallSplit, mdiSourceBranch } from '@mdi/js'

import { formatPackageIdList } from '../format'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateSplitTags',
  props: {
    originPackageId: {},
    splitToPackageIds: {},
    mergedFromPackageIds: { default: () => [] },
    testId: { default: 'affiliate-split-tags' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.mergedFromPackageIds.length || _ctx.splitToPackageIds.length || _ctx.originPackageId)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "inline-flex flex-wrap gap-1 align-middle",
        "data-testid": _ctx.testId
      }, [
        (_ctx.mergedFromPackageIds.length)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "inline-flex max-w-full items-center gap-0.5 whitespace-normal break-words rounded border border-current px-1.5 text-[11px] font-bold text-teal-700",
              "data-testid": `${_ctx.testId}-merged`
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                _createElementVNode("path", { d: _unref(mdiCallMerge) }, null, 8, _hoisted_4)
              ])),
              _createTextVNode(" Reúne " + _toDisplayString(_unref(formatPackageIdList)(_ctx.mergedFromPackageIds)), 1)
            ], 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.originPackageId)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "inline-flex items-center gap-0.5 whitespace-nowrap rounded border border-current px-1.5 text-[11px] font-bold text-blue-700",
              "data-testid": `${_ctx.testId}-origin`
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                _createElementVNode("path", { d: _unref(mdiSourceBranch) }, null, 8, _hoisted_7)
              ])),
              _createTextVNode(" Veio do #" + _toDisplayString(_ctx.originPackageId), 1)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.splitToPackageIds.length)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "inline-flex items-center gap-0.5 whitespace-nowrap rounded border border-current px-1.5 text-[11px] font-bold text-orange-700",
              "data-testid": `${_ctx.testId}-split`
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                _createElementVNode("path", { d: _unref(mdiCallSplit) }, null, 8, _hoisted_10)
              ])),
              _createTextVNode(" Dividido ")
            ], 8, _hoisted_8))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})